// Toggle Navbar
const handleToggle = () => {
  const element = document.getElementById('menu');
  const menuToggle = document.getElementById('menuToggle');
  const header = document.getElementById('main-header');
  const menuToggles = document.querySelectorAll('#menuToggle .line');
  const navIcons = document.querySelectorAll('.nav-icon');
  const logo = document.getElementById('logo');
  const isOpening = !menuToggle.classList.contains('active');

  element.classList.toggle('navbar-active');
  menuToggle.classList.toggle('active');

  if (isOpening) {
    header.classList.add('scrolled');
    menuToggles.forEach((item) => item.classList.add('color-black'));
    navIcons.forEach((item) => item.classList.add('home-filter-black'));
    logo.classList.remove('home-filter-white');
  } else {
    if (window.scrollY <= 50) {
      setTimeout(() => {
        if (window.scrollY <= 50 && !menuToggle.classList.contains('active')) {
          header.classList.remove('scrolled');
          menuToggles.forEach((item) => item.classList.remove('color-black'));
          navIcons.forEach((item) => item.classList.remove('home-filter-black'));
          logo.classList.add('home-filter-white');
        }
      }, 800);
    }
  }
};

// Toggle Dropdowns
function toggleDropdown(listId, iconId) {
  const dropdownList = document.getElementById(listId);
  const dropdownIcon = document.getElementById(iconId);

  dropdownList.classList.toggle('h-0');
  dropdownList.classList.toggle('opacity-0');
  dropdownList.classList.toggle('h-auto');
  dropdownList.classList.toggle('opacity-100');
  dropdownIcon.classList.toggle('rotate-45'); // Rotate "+" to "x"
}

// Toggle Filters Table
const handleFilterToggle = () => {
  const filterToggle = document.getElementById('filterToggle');
  const filtersTable = document.getElementById('filtersTable');
  filterToggle.classList.toggle('active');
  filtersTable.classList.toggle('active');
};

// Function to handle adding/removing the active class
// const setActiveFilter = (elements, activeClass, selectedElement) => {
//   elements.forEach((el) => {
//     el.classList.remove(activeClass); // Remove the active class from all elements
//   });
//   selectedElement.classList.add(activeClass); // Add the active class to the selected element
// };

// Select all price filter list items
const priceFilters = document.querySelectorAll('.filter-price li');

// Restore the active filter from localStorage on page load
// document.addEventListener('DOMContentLoaded', () => {
//   const activeFilterData = localStorage.getItem('activeFilter'); // Get stored filter
//   if (activeFilterData) {
//     const activeFilter = document.querySelector(`.filter-price li[data-gte="${activeFilterData}"]`);
//     if (activeFilter) {
//       setActiveFilter(priceFilters, 'font-bold', activeFilter); // Reapply active class
//     }
//   }
// });

// Add event listeners to each filter
priceFilters.forEach((filter) => {
  filter.addEventListener('click', () => {
    // Apply active class to the clicked filter
    // setActiveFilter(priceFilters, 'font-bold', filter);

    // Get the gte and lte values from the data attributes
    const gtePrice = filter.getAttribute('data-gte');
    const ltePrice = filter.getAttribute('data-lte');

    // Save the active filter to localStorage
    localStorage.setItem('activeFilter', gtePrice);

    // Construct the URL for Shopify filters
    const url = new URL(window.location.href);

    // Set availability and price range parameters
    url.searchParams.set('filter.v.price.gte', gtePrice);

    if (ltePrice) {
      // If lte is provided, add it to the URL
      url.searchParams.set('filter.v.price.lte', ltePrice);
    } else {
      // If lte is empty, remove it from the URL
      url.searchParams.delete('filter.v.price.lte');
    }

    // Redirect to the updated URL
    window.location.href = url.toString();
  });
});

// Function to handle sorting
function handleSort(sortValue) {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', sortValue);
  window.location.href = url.toString();
}

// Function to reset filter when no filter is applied
function resetFilter() {
  localStorage.removeItem('activeFilter'); // Remove filter from localStorage
  priceFilters.forEach((filter) => {
    filter.classList.remove('font-bold'); // Remove active class from all filters
  });
}

function toggle_sort_by() {
  const customSortList = document.querySelector('.custom-sort-list');

  if (customSortList) {
    customSortList.classList.toggle('active');
  }

  const customSortHeading = document.querySelector('.custom-sort-heading');

  if (customSortHeading) {
    customSortHeading.classList.toggle('active');
  }
}
document.addEventListener('DOMContentLoaded', function () {
  const defaultSelect = document.getElementById('SortBy-mobile');
  const customSortList = document.querySelector('.custom-sort-list');

  if (customSortList && defaultSelect) {
    customSortList.querySelectorAll('li').forEach((item) => {
      item.addEventListener('click', function () {
        const sortValue = this.getAttribute('data-sort-value');
        console.log('Selected sort value:', sortValue); // Debug

        // Find the corresponding option in the default select
        const targetOption = Array.from(defaultSelect.options).find((option) => option.value === sortValue);

        if (targetOption) {
          // Set the select value
          defaultSelect.value = sortValue;
          console.log('Set select value to:', defaultSelect.value); // Debug

          // Dispatch multiple events to ensure the change is captured
          ['input', 'change'].forEach((eventType) => {
            const event = new Event(eventType, {
              bubbles: true,
              cancelable: true,
            });
            defaultSelect.dispatchEvent(event);
            console.log(`Dispatched ${eventType} event`); // Debug
          });
        }
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const header = document.getElementById('main-header');
  const menuToggles = document.querySelectorAll('#menuToggle .line');
  const navIcons = document.querySelectorAll('.nav-icon');
  const logo = document.getElementById('logo');

  window.addEventListener('scroll', function () {
    const menuToggle = document.getElementById('menuToggle');
    const menu = document.getElementById('menu');

    if (menuToggle.classList.contains('active')) {
      menu.classList.remove('navbar-active');
      menuToggle.classList.remove('active');
      menuToggles.forEach((item) => item.classList.remove('color-black'));
      navIcons.forEach((item) => item.classList.remove('home-filter-black'));

      if (window.scrollY <= 50) {
        header.classList.remove('scrolled');
        logo.classList.add('home-filter-white');
      }
    }

    if (window.scrollY > 50) {
      header.classList.add('scrolled');
      menuToggles.forEach((item) => item.classList.add('color-black'));
      navIcons.forEach((item) => item.classList.add('home-filter-black'));
      logo.classList.remove('home-filter-white');
    } else {
      header.classList.remove('scrolled');
      menuToggles.forEach((item) => item.classList.remove('color-black'));
      navIcons.forEach((item) => item.classList.remove('home-filter-black'));
      logo.classList.add('home-filter-white');
    }
  });
});

// Set up the click outside detection
function setupClickOutsideHandler() {
  document.addEventListener('click', function (event) {
    const open = document.querySelector('.menu-opening.filter-menu-open');
    const form = document.getElementById('FacetFiltersFormMobile');
    // If form exists and the clicked element is NOT inside the form
    if (form && !form.contains(event.target) && open) {
      // Your custom function to call when clicking outside
      document.querySelector('.mobile-facets__wrapper').querySelector('summary').click();
    }
  });
}

//remove &nbsp
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-clean-nbsp').forEach(function (el) {
    el.querySelectorAll('p').forEach(function (p) {
      // Skip empty spacer paragraphs - leave them completely alone
      var content = p.innerHTML.trim();
      if (content === '&nbsp;' || content === '\u00A0' || content === ' ' || content === '') {
        return; // do nothing, keep the spacer
      }

      // Only fix &nbsp; inside paragraphs that have real content
      p.innerHTML = p.innerHTML.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
      console.log('nbsp');
    });
  });
});
